import { Box, Typography } from '@mui/material';
import { PALETTE } from '@/styles/constants';

const STEPS = [
  { num: 'I', label: 'Apply & Qualify', active: true },
  { num: '2', label: 'Receive Funds' },
  { num: '3', label: 'Live Payment-Free' },
  { num: '4', label: 'Repay Anytime' },
];

export default function HowItWorksStepper() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: { xs: '48px 24px', md: '64px 60px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          maxWidth: '640px',
          gap: { xs: '4px', sm: '8px', md: '12px' },
        }}
      >
        {STEPS.map((step, i) => (
          <Box
            key={step.label}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flex: i === STEPS.length - 1 ? '0 0 auto' : '1 1 auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-3px)' },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: step.active ? { xs: '64px', md: '84px' } : { xs: '52px', md: '68px' },
                  height: step.active ? { xs: '64px', md: '84px' } : { xs: '52px', md: '68px' },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&::before': step.active
                    ? {
                        content: '""',
                        position: 'absolute',
                        inset: '-10px',
                        borderRadius: '50%',
                        background: `radial-gradient(circle, ${PALETTE.goldSoft}55 0%, transparent 72%)`,
                      }
                    : undefined,
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    border: step.active
                      ? `1.5px solid ${PALETTE.gold}`
                      : '1px solid rgba(168, 129, 63, 0.45)',
                    background: `linear-gradient(145deg, ${PALETTE.parchment} 0%, ${PALETTE.parchmentDeep} 100%)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease',
                    boxShadow: step.active
                      ? `0 6px 16px -4px rgba(28, 25, 17, 0.25), 0 2px 4px rgba(28, 25, 17, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.6)`
                      : `0 3px 8px -2px rgba(28, 25, 17, 0.18), inset 0 1px 1px rgba(255, 255, 255, 0.5)`,
                    '.MuiBox-root:hover > &': {
                      borderColor: PALETTE.gold,
                      boxShadow: `0 8px 20px -4px ${PALETTE.gold}55, inset 0 1px 1px rgba(255, 255, 255, 0.6)`,
                      transform: 'scale(1.04)',
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Georgia, "Times New Roman", serif',
                      fontSize: step.active
                        ? { xs: '22px', md: '30px' }
                        : { xs: '16px', md: '20px' },
                      color: step.active ? PALETTE.gold : PALETTE.inkSoft,
                    }}
                  >
                    {step.num}
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: '11.5px',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  textAlign: 'center',
                  color: step.active ? PALETTE.gold : PALETTE.inkSoft,
                  maxWidth: '90px',
                  lineHeight: 1.4,
                }}
              >
                {step.label}
              </Typography>
            </Box>
            {i < STEPS.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: '1px',
                  minWidth: { xs: '16px', md: '32px' },
                  marginX: { xs: '4px', md: '8px' },
                  marginBottom: { xs: '38px', md: '48px' },
                  background: `linear-gradient(90deg, ${PALETTE.gold}88, rgba(168, 129, 63, 0.25))`,
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
